<app-breadcrumb [pathList]="pathList"></app-breadcrumb>
<div [ngBusy]="{busy: busy, message: 'Loading...', backdrop: false, delay: 0, minDuration: 600}"></div>
<div class="container-fluid">
    <app-single-player (pathListEvent)="loga($event)" [id]="id" [single]="single" [componentService]="realPlayerService" [routePart]="'real_player'" ></app-single-player>
    <app-alertbox #alertbox1 [alerts]=""></app-alertbox>
</div>